import Icon, { GenericIconProps } from '../Icon';

const CalendarCheckIcon: React.FC<GenericIconProps> = ({ className }) => {
  const svg = {
    viewBox: '0 0 19 18',
  };

  const path = [
    {
      // eslint-disable-next-line max-len
      d: 'M15.1137 3.3443V1.55921C15.1137 1.32249 15.0197 1.09547 14.8523 0.928084C14.6849 0.7607 14.4579 0.666664 14.2212 0.666664C13.9844 0.666664 13.7574 0.7607 13.59 0.928084C13.4227 1.09547 13.3286 1.32249 13.3286 1.55921V3.3443H6.18827V1.55921C6.18827 1.32249 6.09423 1.09547 5.92685 0.928084C5.75947 0.7607 5.53244 0.666664 5.29573 0.666664C5.05901 0.666664 4.83199 0.7607 4.6646 0.928084C4.49722 1.09547 4.40318 1.32249 4.40318 1.55921V3.3443H0.833008V17.625H18.6839V3.3443H15.1137ZM16.8988 15.8399H2.6181V5.12938H16.8988V15.8399ZM13.3822 9.07443L12.3111 8.00337L9.13367 11.1808L7.21126 9.25843L6.14021 10.3295L9.13916 13.3284L13.3822 9.07443Z',
    },
  ];

  return <Icon className={className} svg={svg} path={path} />;
};

export default CalendarCheckIcon;
